import { render, staticRenderFns } from "./ReturnGen.vue?vue&type=template&id=ab128c46"
import script from "./ReturnGen.vue?vue&type=script&lang=js"
export * from "./ReturnGen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports